import { useCallback, useEffect, useState } from "react";

import { useSubscribe } from "data/messages/hooks";

export function useSubscribeToNextWorkflow(onUpdate) {
  const [isRefetch, refetch] = useState(false);

  useEffect(() => {
    if (isRefetch) {
      onUpdate();
      refetch(false);
    }
  }, [isRefetch, onUpdate]);

  useSubscribe(
    "nextWorkflows",
    useCallback((reloadSet) => {
      if (reloadSet && reloadSet.values().next().value) refetch(true);
    }, [])
  );
}

export default useSubscribeToNextWorkflow;
